// extracted by mini-css-extract-plugin
export default {"label":"ToastNotification_label__kgkQJ","msg":"ToastNotification_msg__Ufa+U"};